<template>
    <div class="tabs_content" id="tab-1">
        <section>
            <div class="left">
              <detail-entity-info :entity="entity" v-if="entity.id">
                <p><translate>Počet zařízení</translate>: <span class="date">{{ entity.device_count }}</span></p>
              </detail-entity-info>
                <h2 v-else v-translate>Základní údaje</h2>
            </div>

            <div class="right">

                <div class="field_left">
                    <text-input id="devicetypename"
                                :required="true"
                                v-model="entity.name"
                                ref="nameref"
                                :disabled="!isEditable"
                    >
                        <translate class="translate">Název</translate>
                    </text-input>

                    <text-input id="devicetypecode"
                                :required="true"
                                v-model="entity.code"
                                ref="coderef"
                                :disabled="!isEditable"
                    >
                        <translate class="translate">Kód</translate>
                    </text-input>
                </div>

                <div class="field_right">
                    <select-box
                        id="idDeviceType"
                        v-model="deviceTypeIdComputed"
                        :options="deviceGroupOptions"
                        :required=true
                        :disabled="!isEditable"
                    >
                        <translate class="translate">Skupina zařízení</translate>
                    </select-box>
                </div>

                <textarea-input
                    id="note"
                    rows=6
                    cols=50
                    v-model="entity.description"
                    :disabled="!isEditable"
                >
                    <translate class="translate">Poznámka</translate>
                </textarea-input>

                <checkbox-input
                    id="deviceTypeExtraTracks"
                    v-model="entity.allow_extra_tracks"
                    @input="onAllowExtraTracksChange"
                    ref="devicetypeextratracksref"
                    :disabled="!isEditable"
                >
                    <translate class="translate">Povolit oddělené stopy na zařízení</translate>
                </checkbox-input>
              <checkbox-input
                  id="deviceTypeExtraAudio"
                  v-model="entity.allow_extra_audio"
                  :disabled="!isEditable || !allowExtraCheckboxes"
                  ref="devicetypeextraaudioref"
              >
                <translate class="translate">Oddělené stopy pro audio</translate>
              </checkbox-input>
              <checkbox-input
                  id="deviceTypeExtraSubs"
                  v-model="entity.allow_extra_subs"
                  :disabled="!isEditable || !allowExtraCheckboxes"
                  ref="devicetypeextrasubsref"
              >
                <translate class="translate">Oddělené stopy pro titulky</translate>
              </checkbox-input>
            </div>

        </section>

        <section>
            <div class="left">
                <h2 v-translate>Podporované protokoly</h2>
            </div>

            <div class="right checkbox_group">

                <ul>
                    <li v-for="protocol in this.protocols" :key="'protocol_' + protocol.id">
                        <input
                            v-model="entity.supported_id_protocols"
                            :id="'prot_' + protocol.id"
                            name="protocols[]"
                            type="checkbox"
                            :value="protocol.id"
                            :disabled="!isEditable"
                        />
                        <label :for="'prot_' + protocol.id">{{ protocol.name }}</label>
                    </li>
                </ul>
            </div>

        </section>
    </div>
</template>

<script>

import DetailEntityInfo from "../../../common/DetailEntityInfo";
export default {
  name: "DeviceTypeDescription",
  components: {DetailEntityInfo},
  props: {
    entity: Object,
    deviceGroups: Array,
    protocols: Array,
    isEditable: Boolean,
    codecs: Array,
    streamProfiles: Array,
  },
  computed: {
      deviceTypeIdComputed: {
          get() {
              if (this.entity.id_device_group === null) {
                  return '0'
              } else {
                  return this.entity.id_device_group
              }
          },
          set(newValue) {
              this.entity.id_device_group = newValue
          },
      },
      allowExtraCheckboxes(){
        return this.entity.allow_extra_tracks;
      },
      deviceGroupOptions() {
          let groups = [{'id': 0, name: this.$gettext('Vyberte skupinu zařízení')}, ...this.deviceGroups];
          return this._.map(groups, function (item) {
              return {id: item['id'], text: item['name']}
          })
      },
  },
  methods: {
      onAllowExtraTracksChange(){
        if(!this.entity.allow_extra_tracks){
          this.entity.allow_extra_audio = false;
          this.entity.allow_extra_subs = false;
        }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypes/components/Description.vue